// import logo from './logo.svg';
import "./App.css";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./Home";
import TechTalentProgram from "./component/TechTalentProgram";
import FreelancerForm from "./component/FreelancerForm";
import JoinCommunity from "./component/JoinCommunity";
import MentorForm from "./component/MentorForm";
import DigitalSkills from "./component/DigitalSkills";
import MentorDetails from "./component/MentorDetails";
import CharityProgram from "./programs/CharityProgram";
import ClientLogin from "./login/ClientLogin";
import ClientRegisteration from "./login/ClientRegisteration";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import UserProfile from "./component/UserProfile";
import ClientDashboard from "./component/ClientDashboard";
import AboutUs from "./component/AboutUs";
import Services from "./component/Services";
import Contact from "./component/Contact";
import FreelancerDetails from "./component/FreelancerDetails";
import ProjectForm from "./component/ProjectForm";
import MentorLogin from "./login/MentorLogin";
import MentorRegister from "./login/MentorRegister";
import FreelancerLogin from "./login/FreelancerLogin";

export default function App() {
  return (
    <div>
      <BrowserRouter>
        <ToastContainer />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/services" element={<Services />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/tech-talent-program" element={<TechTalentProgram />} />
          <Route path="/mentor/:id" element={<MentorDetails />} />
          <Route path="/freelancer-form" element={<FreelancerForm />} />
          <Route path="/freelancer-login" element={<FreelancerLogin />} />
          <Route path="/freelancer/:id" element={<FreelancerDetails />} />
          <Route path="/digital-skills-program" element={<DigitalSkills />} />
          <Route path="/mentor-form" element={<MentorForm />} />
          <Route path="/mentor-login" element={<MentorLogin />} />
          <Route path="/mentor-register" element={<MentorRegister />} />
          <Route path="/charity-program" element={<CharityProgram />} />
          <Route path="/join-community" element={<JoinCommunity />} />
          <Route path="/client-login" element={<ClientLogin />} />
          <Route path="/client-form" element={<UserProfile />} />
          <Route path="/client-register" element={<ClientRegisteration />} />
          <Route path="/profile/:id" element={<ClientDashboard />} />
          <Route path="/profile" element={<UserProfile />} />
          <Route path="/project-form" element={<ProjectForm />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
